import { render, staticRenderFns } from "./videoConfMembers.vue?vue&type=template&id=3bf174df&scoped=true&lang=pug&"
import script from "./videoConfMembers.vue?vue&type=script&lang=js&"
export * from "./videoConfMembers.vue?vue&type=script&lang=js&"
import style0 from "./videoConfMembers.vue?vue&type=style&index=0&id=3bf174df&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf174df",
  null
  
)

export default component.exports